export default {
      id: "ic_instagram-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_instagram-usage",
      toString: function () {
        return this.url;
      }
    }